import React from 'react';
import { Box, Typography } from '@mui/material';

export const SERIES_COLORS = ['#1976d2', '#2e7d32', '#ed6c02', '#7b1fa2', '#c2185b', '#00838f', '#827717', '#d32f2f'];

const niceMax = (v) => {
  if (v <= 0) return 1;
  const mag = 10 ** Math.floor(Math.log10(v));
  return [1, 2, 5, 10].map((m) => m * mag).find((m) => m >= v);
};

// A small stacked bar chart drawn as inline SVG. bars: [{ label, values: { key: number } }]; keys sets the stacking order.
export default function ReportingStackedBars({ bars, keys, labels = {}, unit = 'GB', ariaLabel, height = 240 }) {
  const W = 640; const left = 48; const bottom = 26; const top = 8;
  const totals = bars.map((b) => keys.reduce((s, k) => s + Number(b.values[k] || 0), 0));
  const max = niceMax(Math.max(0, ...totals));
  const plotH = height - top - bottom;
  const slot = (W - left - 8) / Math.max(1, bars.length);
  const bw = Math.min(48, slot * 0.7);
  const y = (v) => top + plotH - (v / max) * plotH;
  const every = Math.ceil(bars.length / 12);
  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 0.5 }}>
        {keys.map((k, i) => (
          <Typography key={k} variant="caption"><Box component="span" sx={{ display: 'inline-block', width: 10, height: 10, bgcolor: SERIES_COLORS[i % SERIES_COLORS.length], mr: 0.5 }} />{labels[k] || k}</Typography>
        ))}
      </Box>
      <svg viewBox={`0 0 ${W} ${height}`} width="100%" role="img" aria-label={ariaLabel} style={{ display: 'block' }}>
        {[0, 0.25, 0.5, 0.75, 1].map((f) => (
          <g key={f}>
            <line x1={left} x2={W - 8} y1={y(max * f)} y2={y(max * f)} stroke="currentColor" strokeOpacity="0.12" />
            <text x={left - 6} y={y(max * f) + 4} fontSize="11" textAnchor="end" fill="currentColor" fillOpacity="0.7">{Math.round(max * f).toLocaleString()}</text>
          </g>
        ))}
        {bars.map((b, bi) => {
          const x = left + slot * bi + (slot - bw) / 2;
          let acc = 0;
          return (
            <g key={b.label + bi}>
              {keys.map((k, ki) => {
                const v = Number(b.values[k] || 0);
                if (!v) return null;
                const y1 = y(acc + v);
                const h = y(acc) - y1;
                acc += v;
                return <rect key={k} x={x} y={y1} width={bw} height={Math.max(0.5, h)} fill={SERIES_COLORS[ki % SERIES_COLORS.length]}><title>{`${b.label} - ${labels[k] || k}: ${v.toLocaleString()} ${unit}`}</title></rect>;
              })}
              {bi % every === 0 && <text x={x + bw / 2} y={height - 8} fontSize="11" textAnchor="middle" fill="currentColor" fillOpacity="0.7">{b.label}</text>}
            </g>
          );
        })}
      </svg>
    </Box>
  );
}
